// extracted by mini-css-extract-plugin
export var active = "Pagenav-module--active--4a825";
export var feedbackButton = "Pagenav-module--feedback-button--74d07";
export var header = "Pagenav-module--header--7b8e5";
export var list = "Pagenav-module--list--a7412";
export var listItem = "Pagenav-module--list-item--ed2aa";
export var listItemLink = "Pagenav-module--list-item-link--104c2";
export var listItemMethod = "Pagenav-module--list-item-method--73637";
export var pagenav = "Pagenav-module--pagenav--ddc30";